"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartnershipInterstitial = void 0;
var usePartnershipInterstitial_hook_1 = require("./usePartnershipInterstitial.hook");
Object.defineProperty(exports, "usePartnershipInterstitial", { enumerable: true, get: function () { return usePartnershipInterstitial_hook_1.usePartnershipInterstitial; } });
//# sourceMappingURL=index.js.map